/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextBtn from "./TextBtn";
import {Button, Modal, Input} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import InputMark from "./InputMark";
import AddClue from "../../view/clue/addClue";
import ClueDetails from '../../view/clue/clueDetails'
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../../utils";
import AddSolicitation from '../../view/Solicitation/addSolicitation'

import Btn from "../btn/Btn"
import SolicitationDetails from "../../view/Solicitation/SolicitationDetails";
import SolicitationChoose from "../../view/Solicitation/SolicitationChoose";

const {TextArea}=Input;
let that;
export default class DialogBtn1000 extends Component {
    static defaultProps = {
        okText:"确定",
        cancelText:"取消",
        modalTitle:'操作'
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            detailsData:'',
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    getBtn(){
        return (<TextBtn btnClick={()=>{
            this.btnClick(this.props.record)
        }} btnText={this.props.btnText} />)
    }

    render() {
        let btn = this.getBtn();
        return (
            <div>
                <style>
                    {
                        `.ant-modal-header{
                            background:#F6F8FD;
                            padding:12px 24px;
                         }
                         .ant-modal-close-x {
                            width:47px;
                            height:47px;
                            line-height:47px;
                         }
                         
                         `
                    }

                </style>
                {btn}
                {/*<TextBtn btnClick={()=>{
                    this.btnClick(this.props.record)
                }} btnText={this.props.btnText} />*/}
                {this.renderModal()}
            </div>
        )
    }

    renderModal(){
        let btn=this.props.btn;

        let isRefresh = btn.execOverRefresh;
        let content=<div>未配置弹窗内容组件</div>;
       if(btn.content === "addNewsClue"){
            content = <AddClue complete={()=>{
                this.complete()
            }} sysConfigKeyParamsVal={btn.configKey} btn={ btn } record={this.props.record}   ref={(InputMark)=>{this.connectChild=InputMark}}/>
        }else if(btn.content === 'clueDetails'){
           content = <ClueDetails complete={()=>{
               this.complete()
           }} sysConfigKeyParamsVal={btn.configKey} btn={ btn } record={this.props.record}   ref={(InputMark)=>{this.connectChild=InputMark}}/>
       }else if(btn.content === 'addSolicitation'){
           content = <AddSolicitation complete={()=>{
               this.complete()
           }} sysConfigKeyParamsVal={btn.configKey} btn={ btn } record={this.props.record}   ref={(InputMark)=>{this.connectChild=InputMark}}/>
       }else if(btn.content === 'solicitationDetails'){
           content = <SolicitationDetails complete={()=>{
               this.complete()
           }} sysConfigKeyParamsVal={btn.configKey} btn={ btn } record={this.props.record}   ref={(InputMark)=>{this.connectChild=InputMark}}/>
       }else if(btn.content ==='solicitationChoose') {
           content = <SolicitationChoose  complete={(data)=>{
               this.complete(data)
           }} sysConfigKeyParamsVal={btn.configKey} btn={ btn } record={this.props.record}   ref={(InputMark)=>{this.connectChild=InputMark}}/>
       }

        let btn1 = this.props.btn&&this.props.btn.btn1;
        let btn2 = this.props.btn&&this.props.btn.btn2;

        that=this;
        let height = btn.height||669;
        return (

            <Modal

                destroyOnClose={true}
                title={
                    <div >{this.props.modalTitle}</div>
                }
                style={{top: 20}}
                visible={this.state.visible}
                onOk={() => this.setState({visible: false})}
                onCancel={() =>{
                    this.setState({visible: false});
                    // Modal.destroyAll()
                }}
                centered={true}
                width={this.props.btn.width?this.props.btn.width:1000}
                // height={800}
                footer={
                    <div style={{textAlign: "center",display:"flex",alignItems:"center",justifyContent:"center"}}>
                        {this.props.btn&&this.props.btn.cancelText?<Button onClick={() =>this.cancel()}>{this.props.btn&&this.props.btn.cancelText}</Button>:null}
                        {this.props.okText?<Button onClick={() => {this.save()}} style={{background: "#0050B3", color: "#fff"}}>{this.props.okText}</Button>:null}
                        {btn1?<Btn  record={this.props.record}  btnList={btn1}  refresh={() => this.complete()} />:null}
                        {btn2?<Btn  record={this.props.record}  btnList={btn2}  refresh={() => this.complete()}/>:null}
                    </div>
                }
            >
                <div style={{height:height,width:"100%"}}   key={uuid()}>
                    <Scrollbars style={{ height: height,width:"100%",paddingRight:"20px"}}>
                    {
                        content
                    }
                    </Scrollbars    >
                </div>

            </Modal>
        )
    }

    btnClick  (record){
        //已经有新增的数据了。
        // this.connectChild.onOk()
        let toNewDialog = false;
        if(that.connectChild&&that.connectChild.onOk) {
             toNewDialog =  that.connectChild.toExamine()
            if(!toNewDialog) {
                this.setState({visible:true,detailsData:that.connectChild&&that.connectChild.state})
            }
        }else {
            this.setState({visible:true,})
        }

    }

    cancel(){
        let btn=this.props.btn;
        console.log(btn,'btn')
        if(this.connectChild[btn.cancelFunctionName]){
            console.log(1)
            this.connectChild[btn.cancelFunctionName]()

        }else{
            this.setState({visible:false})

        }
    }

    save(){
        let btn=this.props.btn;
        console.log('---------149--------',this,this.connectChild);
        if(this.connectChild[btn.okFunctionName]){
            this.connectChild[btn.okFunctionName]()
        }else{
            this.complete();
        }
    }
    complete(data){
        let btn=this.props.btn;
        let isRefresh = btn.execOverRefresh;
        this.setState({visible:false},()=>{
            if(isRefresh){
                this.props.refresh&&this.props.refresh(data)
            }
        })
    }


}
